// ./common/views.js

const Views = {
  MANAGE_APPLICANTS: 'manageApplicants',
  QUESTIONAIRE: 'questionaire',
  APPLICANT_DOCUMENTS: 'applicantDocuments',
  APPLICANT_SUMMARIZATION: 'applicantSummarization',
  EVIDENCE: 'evidence',
  DOCASSIST: 'docAssist',
};

export default Views;
